export default "__VITE_ASSET__ClmI280Q__"